import React, { useState } from 'react';
import { Layout, Button, theme, Input } from 'antd';

const { TextArea } = Input;

const { Header, Content, Footer } = Layout;

const Content2: React.FC = () => {
  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();

  const [encryptData, setEncryptData] = useState<string>('')

  return (
    <div>
      ...
    </div>
  );
};

export default Content2;
